'use strict';

var Headroom = require('headroom.js');

var header = function () {
  var headerEl = document.querySelector('.js-fixed-header');
  var DOCKING_POSITION = document.querySelector('.c-panel--intro').offsetHeight;

  var headroomOptions = {
    offset: DOCKING_POSITION,
    classes : {
      // when element is initialised
      initial : "headroom",
      // when scrolling up
      pinned : "is-pinned",
      // when scrolling down
      unpinned : "is-unpinned",
      // when above offset
      top : "at-top",
      // when below offset
      notTop : "not-at-top",
      // when at bottom of scoll area
      bottom : "at-bottom",
      // when not at bottom of scroll area
      notBottom : "not-at-bottom"
    }
  }

  var stickyHeader = new Headroom(headerEl, headroomOptions);
  stickyHeader.init();
};

module.exports = header;
